import { useLiveStreamAppContext } from "../ContextStore/Store";
import axios from "axios";
import { AddUserToRoom } from "../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import SendPlayerSettings from "./SendPlayerSettings";

const StartLiveStream = () => {
  const {
    setLoaderAnimation,
    userExists,
    role,
    setErrorMessage,
    attendeeList,
    apiUrlPost,
    __appConfirmUniqueID,
    __merchantId,
    __userId,
    classesName,
    headers,
    setAttendeeList,
    setAttendees,
    setToken,
    setCommunicationUserId,
    setRecodingIColor,
    setRecordingId,
    setServerCallId,
    setRecordingAction,
    setThreadId,
    setRoomId,
    setHostCommunicationUserId,
    setSessionStartTimeUTC,
    setCurrentDateTimeUTC,
    setJoinRoomAPILoading,
    appInsightTrack,
    appEndTimeUTC,
    currentDateTimeUTC,
  } = useLiveStreamAppContext();
  const { setplayersettings } = SendPlayerSettings();
  const navigate = useNavigate();

  //Funtion to Start the Meeting
  async function startClassCall() {
    setLoaderAnimation(true);
    if (!userExists && role !== "Presenter") {
      setLoaderAnimation(false);
      setErrorMessage("Invalid User!");
      return;
    }
    try {
      if (attendeeList?.length <= 0) {
        setLoaderAnimation(false);
        setErrorMessage("Please Add Attendees");
        return;
      }

      const currentPath = window.location.pathname;
      const newPath = currentPath.includes("/meeting");
      if (!newPath) {
        await setplayersettings();
      }
      try {
        const appEnd = new Date(appEndTimeUTC);
        const current = new Date(currentDateTimeUTC);

        // Add 12 hours (in ms) to appEnd
        const appEndPlus12 = new Date(appEnd.getTime() + 12 * 60 * 60 * 1000);
        if (current > appEndPlus12) {
          console.log("❌ Live Stream ended 12 hours back");
          setErrorMessage("Live Stream has ended. This URL is no longer valid.");
          setLoaderAnimation(false);
          return;
        }

        const joinRoomResponse = await axios.post(
          `${apiUrlPost}joinroom`,
          {
            appConfirmUniqueId: __appConfirmUniqueID,
            attendeeType:
              role === "Presenter" ? 1 : role === "Attendee" ? 2 : 0,
            className: classesName,
            isFromRecordingPlayBack: currentPath.includes("/recording-playback")
          },
          { headers }
        );
        let data = joinRoomResponse.data.data;
        const communityMap = new Map();
        data.attendees.forEach((user) =>
          communityMap.set(user.userId, user.communicationUserId)
        );
        const updatedAttendees = attendeeList.map((attendee) => ({
          ...attendee,
          communicationUserId: communityMap.get(attendee.userId) || null, // Add communicationUserId if a match is found
        }));
        setAttendeeList(updatedAttendees);

        //Initializing State Objects for Individual DropDown
        const updateAttendees = data.attendees.map((attendee) => {
          return {
            communicationUserId: attendee.communicationUserId,
            isPinned: false,
            isMute: false,
            isVideoDisabled: false,
            isChatDisabled: false,
            isScreenShareDisabled: false,
          };
        });
        updateAttendees.push({
          communicationUserId: data.hostDetail.communicationUserId, // Replace with the appropriate value
          isPinned: false,
          isMute: false,
          isVideoDisabled: false,
          isChatDisabled: false,
          isScreenShareDisabled: false,
        });
        setAttendees(updateAttendees);

        //Set Role Wise Data From Join Room Response
        if (data) {
          const roleWiseData =
            role === "Presenter"
              ? data.hostDetail
              : data.attendees.find((attendee) => attendee.userId === __userId);
          setToken(roleWiseData.token);
          setCommunicationUserId({
            communicationUserId: roleWiseData.communicationUserId,
          });

          //// FOR RECORDING
          setRecordingId(data.hostDetail.recordingId);
          setServerCallId(data.hostDetail.serverCallId);
          if (data.hostDetail.recordingAction) {
            setRecordingAction(data.hostDetail.recordingAction);
          }

          if (
            data.hostDetail.recordingAction === 1 ||
            data.hostDetail.recordingAction === 3
          ) {
            setRecodingIColor("#D83F34");
          }
          setThreadId(data.hostDetail.threadId);
          setRoomId(data.hostDetail.roomId);
          setHostCommunicationUserId(data.hostDetail.communicationUserId);
          setSessionStartTimeUTC(data.hostDetail.sessionStartTimeUTC);
          setCurrentDateTimeUTC(data.hostDetail.currentDateTimeUTC);
          setJoinRoomAPILoading(false);

          const userRole = role;

          //Add User To Room Function for the Case Waiting for Host to Start Class
          if (userRole && roleWiseData?.communicationUserId) {
            const contextData = {
              __merchantId,
              __userId,
              appInsightTrack,
              addUserToRoomUrl: `${apiUrlPost}addusertoroom`,
              headers,
            };
            try {
              await AddUserToRoom(
                roleWiseData.communicationUserId,
                data.hostDetail.roomId,
                "Presenter",
                contextData
              );
            } catch (error) {
              // Let the outer catch handle user-facing error messaging
              throw error;
            }
          } else {
            throw new Error("Invalid userId!");
          }

          if (data.hostDetail.roomId) {
            if (!(navigator.userAgent.includes("Macintosh") && /^((?!chrome|android).)*safari/i.test(navigator.userAgent))) {
              const currentPath = window.location.pathname;
              const newPath = currentPath.replace("/start", "/meeting");
              navigate(newPath + window.location.search);
            }
          }
        }
        appInsightTrack(__merchantId, __userId, "Join Room API success", "", "User Joined Room");
      } catch (error) {
        console.error("Error initializing:", error);
        if (error.message.toLowerCase().includes("failed to fetch")) {
          setErrorMessage("We’re having trouble connecting to the Livestream. Please try again.");
        }
        else {
          setErrorMessage(error.message);
        }
        setLoaderAnimation(false);
        appInsightTrack(__merchantId, __userId, "API Error joinroom", "", error);
      }
    } catch (e) {
      console.error("Error starting call:", e);
      appInsightTrack(__merchantId, __userId, "Error starting call", "", e);
    }
    if (!(navigator.userAgent.includes("Macintosh") && /^((?!chrome|android).)*safari/i.test(navigator.userAgent))) {
      setLoaderAnimation(false);
    }
  }
  return { startClassCall }
}

export default StartLiveStream